<template>
        <div class="w-full h-full flex flex-col justify-center items-center">
            <div class="w-20 mb-2 rounded-full flex justify-center items-center">
                <img src="../../icons//no_chat.svg" alt="no message" />
            </div>
            <div class="text-center mt-1">
                <h3 class="text-lg font-medium text-gray-800">No New Messages Yet</h3>
                <p class="text-sm text-gray-500 mt-2">Send the dispatcher a message to start the conversation!</p>
            </div>
        </div>

</template>

<script>
    export default {
        name: "noMessageWidget",
    }
</script>

<style lang="scss" scoped>

</style>